export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="fixed left-4 top-4 z-[100] -translate-y-24 rounded-md bg-ink px-4 py-2 font-sans text-sm font-medium text-white transition-transform focus:translate-y-0 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-gold"
    >
      Vai al contenuto principale
    </a>
  )
}
